import { Box, Skeleton, useTheme } from "@mui/material";
import React from "react";
import PaperContainer from "../PaperContainer";

const SkeletonPDFPreview = () => {
  const theme = useTheme();

  const renderRow = (cols: number[]) => (
    <Box display="flex" width="100%" mb={1}>
      {cols.map((width, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          width={`${width}%`}
          height={18}
          sx={{ mr: index !== cols.length - 1 ? 1 : 0, borderRadius: 0.5 }}
        />
      ))}
    </Box>
  );

  return (
    <PaperContainer>
      <Box
        width="100%"
        p={3}
        display="flex"
        flexDirection="column"
        gap={2}
        bgcolor="#fff"
      >
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Skeleton variant="rectangular" width={80} height={60} />
          <Box mt={2} width="40%">
            <Skeleton variant="text" width="80%" height={18} />
            <Skeleton variant="text" width="60%" height={18} />
            <Skeleton variant="text" width="90%" height={24} />
          </Box>
        </Box>

        <Skeleton variant="text" width="30%" height={16} />
        <Skeleton variant="text" width="40%" height={16} />
        <Skeleton variant="text" width="35%" height={16} />

        {renderRow([10, 30, 15, 10, 10, 15])}

        {Array.from({ length: 4 }).map((_, i) => (
          <React.Fragment key={i}>
            {renderRow([10, 30, 15, 10, 10, 15])}
          </React.Fragment>
        ))}

        <Box mt={2} ml="auto" width="30%">
          <Skeleton variant="text" width="80%" height={18} />
          <Skeleton variant="text" width="60%" height={18} />
          <Skeleton variant="text" width="90%" height={24} />
        </Box>

        <Box mt={4} textAlign="center">
          <Skeleton variant="text" width="60%" height={14} />
        </Box>
      </Box>
    </PaperContainer>
  );
};

export default SkeletonPDFPreview;
